<template>
    <div class="window bg">
        <characters-selection v-if="!goNext"></characters-selection>

    </div>
</template>

<script>
    import Logo from '../components/Logo.vue'
    import CharactersSelection from "../components/CharactersSelection";
    import anime from 'animejs';

    export default {
        name: "Selection",
        components: {
            Logo,
            CharactersSelection
        },
        methods: {

        },
        data() {
            return {
                goNext: false
            }
        }
    }
</script>

<style scoped>

</style>
